var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-btn',{staticClass:"col-auto",attrs:{"flat":"","no-caps":"","padding":"3px 8px 0","disable":_vm.isDisabled},on:{"click":_vm.openRecordModal}},[_c('label',{staticClass:"cursor-pointer"},[_c('RecordVoiceIcon'),_c('q-tooltip',{attrs:{"content-style":"font-size: 12px; padding: 4px 8px; border-radius: 4px;"}},[_vm._v("Gravar Áudio")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }